import { render, staticRenderFns } from "./DeviceChart.vue?vue&type=template&id=aaab66aa&scoped=true&"
import script from "./DeviceChart.vue?vue&type=script&lang=js&"
export * from "./DeviceChart.vue?vue&type=script&lang=js&"
import style0 from "./DeviceChart.vue?vue&type=style&index=0&id=aaab66aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab66aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaab66aa')) {
      api.createRecord('aaab66aa', component.options)
    } else {
      api.reload('aaab66aa', component.options)
    }
    module.hot.accept("./DeviceChart.vue?vue&type=template&id=aaab66aa&scoped=true&", function () {
      api.rerender('aaab66aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/analytics/DeviceChart.vue"
export default component.exports